import { useNavigate } from "@tanstack/react-router";
import { useMemo, useRef } from "react";

import { HotelAboutCard } from "@/features/hotels/components/hotel/HotelAboutCard";
import { HotelContactDetails } from "@/features/hotels/components/hotel/HotelContactDetails";
import { HotelDetailsCard } from "@/features/hotels/components/hotel/HotelDetailsCard";
import { HotelFacilitiesCard } from "@/features/hotels/components/hotel/HotelFacilitiesCard";
import { HotelLocationCard } from "@/features/hotels/components/hotel/HotelLocationCard";
import type { HotelData } from "@/features/hotels/types/types";
import { buildHotelFacilitiesDisplayModel } from "@/features/hotels/utils/facilities/buildHotelFacilitiesDisplayModel";

interface HotelOverviewProps {
  hotel: HotelData;
}

export const HotelOverview = ({ hotel }: HotelOverviewProps) => {
  const navigate = useNavigate();
  const facilitiesSectionRef = useRef<HTMLElement | null>(null);
  const facilitiesModel = useMemo(
    () => buildHotelFacilitiesDisplayModel(hotel.descriptions?.facilities),
    [hotel.descriptions?.facilities],
  );

  return (
    <div className="flex flex-col gap-2">
      <HotelDetailsCard
        hotel={hotel}
        onImageTap={() => {
          navigate({
            to: "/hotels/$id/details/images",
            params: { id: hotel.id },
          });
        }}
        onSeeAll={() => {
          facilitiesSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }}
        facilitiesModel={facilitiesModel}
      />

      <HotelAboutCard hotel={hotel} />

      <HotelLocationCard hotel={hotel} />

      <HotelFacilitiesCard
        hotel={hotel}
        sectionRef={facilitiesSectionRef}
        facilitiesModel={facilitiesModel}
      />

      <HotelContactDetails hotel={hotel} />
    </div>
  );
};
